<div class="progress-toast">
    <div class="progress-toast__header">
        <div class="progress-toast__text">
            @if (data?.title) {
                <div class="progress-toast__title">{{ data.title }}</div>
            }
            @if (data?.subtitle) {
                <div class="progress-toast__subtitle">{{ data.subtitle }}</div>
            }
        </div>

        @if (data?.cancelable) {
            <button mat-icon-button
                    class="progress-toast__cancel"
                    type="button"
                    (click)="onCancel()"
                    [matTooltip]="data?.cancelLabel || 'Abbrechen'"
                    [attr.aria-label]="data?.cancelLabel || 'Abbrechen'">
                <fa-icon icon="xmark"></fa-icon>
            </button>
        }
    </div>

    <mat-progress-bar
        class="progress-toast__bar"
        [mode]="isDeterminate ? 'determinate' : 'indeterminate'"
        [value]="percent">
    </mat-progress-bar>

    <div class="progress-toast__meta">
        @if (isDeterminate) {
            <span class="progress-toast__count">{{ loaded }} / {{ total }}</span>
            <span class="progress-toast__percent">{{ percent }} %</span>
        } @else {
            <span class="progress-toast__count">{{ loaded }} geladen</span>
        }
    </div>
</div>
